import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasButtonComponent } from './gas-button.component';
import { GasIconsModule } from './../../utils/gas-icons/gas-icons.module';
import { GasSpinnerModule } from '../../common/gas-spinner/gas-spinner.module';

const COMPONENTS = [
  GasButtonComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
    GasSpinnerModule,
  ],
})
export class GasButtonModule { }
